import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/global.css'

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'))
}

const analyticsUrl = import.meta.env.VITE_ANALYTICS_SCRIPT_URL as string | undefined
const analyticsWebsiteId = import.meta.env.VITE_ANALYTICS_WEBSITE_ID as string | undefined
if (analyticsUrl && analyticsWebsiteId) {
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = analyticsUrl
  script.dataset.websiteId = analyticsWebsiteId
  document.head.appendChild(script)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
